import { defaultFlags, FeatureFlagName, FeatureFlags, liteVersionFlags } from '@/features'
import { ROOT_CONFIG } from '@/utils/config'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const getFlagsConfig = (): FeatureFlags => {
  return ROOT_CONFIG.isLite ? liteVersionFlags : defaultFlags
}

export const useFeatureFlagsStore = defineStore(
  'featureFlags',
  () => {
    const flags = ref<FeatureFlags>(getFlagsConfig())

    const can = (flag?: FeatureFlagName, strict?: boolean): boolean => {
      if (strict && !flag) return false
      if (!ROOT_CONFIG.isProduction || !flag) return true

      return flags.value[flag]
    }

    const resetFeatureFlags = () => {
      flags.value = getFlagsConfig()
    }

    const setFeatureFlag = (flag: FeatureFlagName, value: boolean) => {
      flags.value = {
        ...flags.value,
        [flag]: value,
      }
    }

    return {
      flags,
      can,
      setFeatureFlag,
      resetFeatureFlags,
    }
  },
  { persist: true },
)

export const addFlagsSettingGlobalMethod = () => {
  const store = useFeatureFlagsStore()

  if (!window) return
  ;(window as any).setFeatureFlag = store.setFeatureFlag
  ;(window as any).resetFeatureFlags = store.resetFeatureFlags
  ;(window as any).logFeatureFlags = () => console.log(store.flags)
}
